"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildRequestOptionsJsonBody = void 0;
exports.default = request;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function handleJSON(text) {
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}
function parseJSON(response) {
  return response.text().then(function (text) {
    return text ? handleJSON(text) : {};
  });
}
function checkStatus(_x) {
  return _checkStatus.apply(this, arguments);
}
function _checkStatus() {
  _checkStatus = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(response) {
    var error;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(response.status >= 200 && response.status < 300)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", response);
          case 2:
            error = new Error(response.statusText);
            error.response = response;
            _context.next = 6;
            return parseJSON(response);
          case 6:
            error.details = _context.sent;
            throw error;
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkStatus.apply(this, arguments);
}
function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    method: "GET"
  };
  var prepOptions = Object.assign(options, {
    credentials: "include"
  });
  return fetch(url, prepOptions).then(checkStatus).then(parseJSON);
}
var buildRequestOptionsJsonBody = function buildRequestOptionsJsonBody(method, body, extraHeaders, extraOptions) {
  return _objectSpread({
    method: method,
    body: JSON.stringify(body),
    headers: _objectSpread({
      Accept: "application/json",
      "Content-Type": "application/json"
    }, extraHeaders)
  }, extraOptions);
};
exports.buildRequestOptionsJsonBody = buildRequestOptionsJsonBody;